import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { withStyles } from '@material-ui/core';

import { getSharedProfile } from '../redux/modules/user/action';
import { SERVER_ADDR } from '../constants';

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    form: {
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    error: {
        marginTop: 10,
        color: theme.palette.error.dark,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    title: {
        marginTop: 10,
    }
});

class ShowProfile extends React.Component {
    state = {
        message: null
    };

    componentDidMount() {
        const { dispatch, match } = this.props;
        dispatch(getSharedProfile(match.params.id));
    }

    render() {
        const { shareUserDetails = { userDetail: {} } } = this.props;
        const { message, error } = this.state;

        console.log('shareUserDetails', shareUserDetails);
        const name = shareUserDetails.userDetail ?
            (`${shareUserDetails.userDetail.firstName} ${shareUserDetails.userDetail.lastName}`) :
            '';

        const address = `${shareUserDetails.userDetail && shareUserDetails.userDetail.address} ${shareUserDetails.userDetail && shareUserDetails.userDetail.city} ${shareUserDetails.userDetail && shareUserDetails.userDetail.country}`;
        const image = `${SERVER_ADDR}/public/assets/${shareUserDetails.userDetail && shareUserDetails.userDetail.image}` || '';

        return (
            <React.Fragment>
                <Helmet>
                    <meta property="al:ios:url" content="programmableweb://news/1331" />
                    <meta property="al:ios:app_store_id" content="44492821" />
                    <meta property="al:ios:app_name" content="PPW for iOS App" />
                    <meta property="og:title" content="ProgrammableWeb News" />
                    <meta property="al:android:url" content="sharesample://story/1234" />
                    <meta property="al:android:package" content="com.facebook.samples.sharesample" />
                    <meta property="al:android:app_name" content="ShareSample" />
                    <meta property="og:title" content="example page title" />
                    <meta property="og:type" content="website" />
                </Helmet>

                <header class="menu_logo back">
                    <div class="left_logo">
                        <img alt="" src="../../public/images/logo.png" />
                    </div>
                    <div class="right_logo">
                        <img alt="" src={`${image}`} />
                        <h3>{name}</h3>

                    </div>
                </header>
                <div class="container">
                    <section class="menu_list">
                        <div class="list_40 ">
                            <div class="profiles ">
                                <img  alt="" src={`${image}`} style={{ width: "100px" }} />
                                <h3>{name}<br /> <span>{shareUserDetails.roleId === '1' ? 'Roomer' : 'Vacancy'}</span></h3>
                                <h6>{shareUserDetails.userDetail && shareUserDetails.userDetail.tagLine}</h6>
                                <h6>Connections: {shareUserDetails.connection}</h6>
                            </div>
                        </div>
                        <div class="list_60 ">
                            <div class="profiles ">
                                <iframe
                                    src={`https://www.google.com/maps/embed/v1/place?q=${address}%5C&key=AIzaSyDtYMExtdWonZI-S9IIW9nyHUd-mZqKL4g`}
                                    width="600"
                                    height="250"
                                    frameborder="0"
                                    style={{ border: 0 }}
                                    allowfullscreen
                                ></iframe>
                            </div>
                        </div>

                    </section>
                    <section class="menu_play">
                        <a href="" ><img alt="" src="images/play.png" />  </a>
                        <a href="" ><img alt="" src="images/apple.png" />  </a>
                    </section>
                </div>
                <footer class="menu_logo back">
                    <div class="foter">
                        <p> Copyright 2019 © RoomerResume. All Rights Reserved.</p>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    shareUserDetails: state.user.shareUserDetails
});

ShowProfile.defaultProps = {
    shareUserDetails: {
        userDetail: {}
    }
}

export default connect(mapStateToProps)(withStyles(styles)(ShowProfile));